import { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Fade, Paper, Portal } from '@material-ui/core';
import useResizeObserver from 'use-resize-observer';

import ResultList from './ResultList';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        zIndex: theme.zIndex.modal,
        backgroundColor: theme.palette.background.paper,

        width: (props) => props.width,
    },
}));

function ResultWindow(props, ref) {
    const { alignmentRef, show, width } = props;
    const classes = useStyles(props);

    const [alignmentStyles, setAlignmentStyles] = useState({ top: -9999 });

    const alignEl = alignmentRef.current;

    useEffect(() => {
        setAlignmentStyles(buildAlignmentStyles(alignEl, width));
    }, [alignEl, width]);

    const bodyRef = useRef(document.body);
    const onResize = useCallback(
        () => setAlignmentStyles(buildAlignmentStyles(alignEl, width)),
        [setAlignmentStyles, width, alignEl]
    );
    useResizeObserver({ ref: bodyRef, onResize });

    const root = document.getElementById('root');

    return (
        <Portal container={root}>
            <Fade in={show} timeout={350}>
                <Paper elevation={4} className={classes.root} style={alignmentStyles} ref={ref}>
                    <ResultList />
                </Paper>
            </Fade>
        </Portal>
    );
}

export default forwardRef(ResultWindow);

function buildAlignmentStyles(alignEl, width) {
    if (!alignEl) {
        return null;
    }

    const { bottom, right } = alignEl.getBoundingClientRect();

    return { left: right - width, top: bottom };
}
